const about = {
  name: "Varun Bhartiya",
  role: "Frontend Developer in React",
  description:
    "Varun is a skilled Frontend Developer in React. He has straightforward communication and advanced English; moreover, and is a sympathetic down-to-earth person. Furthermore, he is familiar with working with best developing practices to enhance product development (DRY principle, modularised code).",
  social: {
    linkedin: "https://www.linkedin.com/in/varun-pramod-bhartiya-09472/",
    github: "https://github.com/vpbhartiya5"
  }
};

const projects = [
  {
    name: "QKart",
    description:
      "This project is an e-commerce application offering a variety of products for customers to choose from. Have implemented the core logic for authentication, shopping cart and checkout.",
    stack: ["React", "React Router V5", "React Hooks", "Debouncing", "Material UI", "REST API"],
    sourceCode: "https://github.com/vpbhartiya5/QKart"
  },

  {
    name: "QTrip Static",
    description:
      "This project is a Static traveling  website for booking tickets for resorts from many cities having various adventures",
    stack: ["HTML", "CSS", "Bootstrap"],
    sourceCode: "https://github.com/vpbhartiya5/QTrip_Static"
  },

  {
    name: "QTrip Dynamic",
    description:
      "This project is a Dynamic traveling  website aimed at travelers looking for a multitude of adventures in different cities.",
    stack: ["HTML", "CSS", "Bootstrap","JavaScript", "DOM", "REST API", "JSON"],
    sourceCode: "https://github.com/vpbhartiya5/QTrip_Dynamic"
  },

  {
    name: "Grocery Store",
    description:
      "This project is a SPA for shopping Groceries built using React along with React Router, Redux and Semantic UI",
    stack: ["HTML", "CSS", "JavaScript", "React", "Redux", "Semantic UI"],
    sourceCode: "https://github.com/vpbhartiya5/grocery-store"
  },

  {
    name: "XBoard",
    description:
      "This project is a News Feed website which aggregates news content from different websites in one place. It consists of news articles grouped under various topics such as Technology, Politics, Sports etc.",
    stack: ["HTML", "CSS", "Bootstrap","JavaScript", "Figma"],
    sourceCode: "https://github.com/vpbhartiya5/XBoard"
  }
];

const skills = ["HTML", "CSS", "Bootstrap", "JavaScript", "React", "Redux", "React Router", "REST API", "DevTools", "Material UI"];

const contact = {
  email: "vpbhartiya5@gmail.com"
};

export { about, projects, skills, contact };
